import React from 'react';
import BarraNavegacao from "../components/BarraNavegacao";
import LogoWebSai from '../assets/websailogowhite.png';
import { BiTrash, BiPlus, BiSave, BiSolidEdit,BiSearch, BiChevronUp, BiChevronDown,BiSearchAlt,BiDownload, BiMeh } from "react-icons/bi";
import { RotatingLines } from 'react-loader-spinner';
import { useState, useEffect } from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2'
import { BsEmojiAngryFill,BsFillEmojiSmileFill,BsFillEmojiFrownFill,BsEmojiNeutralFill,BsEmojiHeartEyesFill } from "react-icons/bs";
import {useLocation} from 'react-router-dom';
import { animateScroll as scroll, scroller } from 'react-scroll'
import PDFFile from "../components/PDFFile";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import axios from 'axios';

export default function EditarQuestionario() {
    
    const location = useLocation();
    const [formulario, setFormulario] = useState({});
    //const [areas, setAreas] = useState([]);
    //const [dimensoes, setDimensoes] = useState([]);
    const [indicadores, setIndicadores] = useState([]);
    const [indicadoresFilter, setIndicadoresFilter] = useState([]);
    const [loading, setLoad] = useState(true); 
    const [btnGravar, setBtnGravar] = useState({});
    const [modal, setModal] = useState(false);
    const [keyModal, setKeyModal] = useState(0);
    const [modalVisualizar, setModalVisualizar] = useState(false);
    const letras = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","X","X","Y","Z"];
    
    useEffect(()=> {
        editFormulario();
    }, []);

    const editFormulario = () => {
        setLoad(true);
        axios.get(process.env.REACT_APP_API + 'Formularios/Agrupados/'+location.state.formularioId, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            setFormulario(response.data.value[0]);
            consultarAreas(response.data.value[0].formularioApelido.tipoUnidade.tipoUnidadeId);
            //setLoad(false);
            scroll.scrollToBottom();//ir para o final da página
            Swal.close();
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarAreas = (tipoUnidadeId) => {
        axios.post(process.env.REACT_APP_API + 'Indicadores/Areas/Generico',{ativo:true}, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200){
                //setAreas(response.data.value);
                consultarDimensao(response.data.value, tipoUnidadeId);
            }
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarDimensao = (listAreas, tipoUnidadeId) => {
        axios.post(process.env.REACT_APP_API + 'Indicadores/Dimensoes/Generico',{ativo:true}, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200){

                response.data.value.forEach((responseDimensao,key) => {
                    let area = listAreas.filter(a => {
                        return a.avaliacaoDimensao.avaliacaoDimensaoId === responseDimensao.avaliacaoDimensaoId
                    })
                    response.data.value[key].areas = area;
                });

                //setDimensoes(response.data.value);
                consultarIndicadores(response.data.value,tipoUnidadeId);
            }
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarIndicadores = (listDimensoes, tipoUnidadeId) => {
        axios.post(process.env.REACT_APP_API + 'Indicadores/Generico',{tipoUnidadeId:tipoUnidadeId,ativo:true}, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200){

                response.data.value.forEach((responseIndicador, key) => {
                    let dimensao = listDimensoes.filter(d => {
                        return d.avaliacaoIndicador.avaliacaoIndicadorId === responseIndicador.avaliacaoIndicadorId
                    })
                    response.data.value[key].dimensoes = dimensao;
                })

                setIndicadores(response.data.value);  
                setIndicadoresFilter(response.data.value);   
                setLoad(false);     
            }
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const handledFormulario = (e, key, altKey) => {
        var updatedList = {...formulario};
        if(altKey === null) //questões
        {
            if(e.target.name === 'questao')
                updatedList.questoes[key].questao = (key+1)+' - '+ e.target.value;
            if(e.target.name === 'textoPreQuestao')
                updatedList.questoes[key].textoPreQuestao = e.target.value;
        }
        else //alternativas
        {
            if(e.target.name === 'descricao')
                updatedList.questoes[key].alternativas[altKey].descricao = letras[altKey] + ' - ' + e.target.value;
        }
        setFormulario(updatedList);
        //habilitano btngravar
        var btn = btnGravar;
        btn[key] = true;
        setBtnGravar(btn);
    };

    const atualizarAlternativas = (key) => {
        var updatedList = {...formulario};
        var respostas = "";
        updatedList.questoes[key].alternativas.forEach((item,indice) => {
            let questaoUpdate = {
                ordem:item.ordem,
                descricao:item.descricao,
                questaoFormularioId:updatedList.questoes[key].questaoFormularioId,
                ativo:true
            }
            axios.put(process.env.REACT_APP_API + 'Alternativas/'+item.questaoAlternativaId,questaoUpdate, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}});
            respostas += item.descricao + ", ";
        });
        if(respostas.length > 0) {
            respostas = respostas.substring(0,respostas.length - 2);
        }
        updatedList.questoes[key].respostas = respostas;
        setFormulario(updatedList);
    }

    const atualizarQuestao = (key) => {
        let envioDados = {
            questaoFormularioId: formulario.questoes[key].questaoFormularioId,
            textoPreQuestao: formulario.questoes[key].textoPreQuestao,
            numeroQuestao: formulario.questoes[key].numeroQuestao,
            questao: formulario.questoes[key].questao,
            respostas: formulario.questoes[key].respostas,
            obrigatorio: formulario.questoes[key].obrigatorio,
            vertical: formulario.questoes[key].vertical,
            quebraPagina: formulario.questoes[key].quebraPagina,
            secao: formulario.questoes[key].secao,
            secaoFinal: formulario.questoes[key].secaoFinal,
            tipoQuestaoId: formulario.questoes[key].tipoQuestao.tipoQuestaoId,
            avaliacaoAreaId: formulario.questoes[key].avaliacaoArea.avaliacaoAreaId,
            formularioId: formulario.formularioId,
            ativo: formulario.questoes[key].ativo
        }
        //atualizando os dados
        axios.put(process.env.REACT_APP_API + 'Questoes/'+formulario.questoes[key].questaoFormularioId,envioDados, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then((response => {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            Swal.close();
            if(response.data.statusCode === 400) {
                Swal.fire({
                    title: 'Não foi possível gravar',
                    text: response.data.value.message,
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
            }
        })).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        });
    }

    const gravar = (key) => {
        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        })
        atualizarAlternativas(key);
        atualizarQuestao(key);
        //ocultar botão gravar
        var btn = btnGravar;
        btn[key] = false;
        setBtnGravar(btn);
    }

    const addAlternativa = (key) => {
        let ordem = formulario.questoes[key].alternativas.length;
        let alternativas = {
            ativo:true,
            descricao: letras[ordem] + " - Alternativa",
            ordem:ordem+1,
            outraResposta:false,
            peso:0,
            questaoFormularioId:formulario.questoes[key].questaoFormularioId
        };

        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        })

        //enviando para o banco 
        axios.post(process.env.REACT_APP_API + 'Alternativas/',alternativas, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then((response => {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200 || response.data.statusCode === 201) {
                //adicionar alternativa em memória
                alternativas.questaoAlternativaId = response.data.value;
                var updatedList = {...formulario};
                updatedList.questoes[key].alternativas.push(alternativas);
                setFormulario(updatedList);
                atualizarAlternativas(key);
                atualizarQuestao(key);          
            }
            else {
                Swal.fire({
                    title: 'Não foi possível gravar',
                    text: response.data.value.message,
                    icon: 'error',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
                return;
            }
        })).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        });
    }

    const addSmile = (key,descricao) => {
        let ordem = formulario.questoes[key].alternativas.length;
        let alternativas = {
            ativo:true,
            descricao: descricao,
            ordem:ordem+1,
            outraResposta:false,
            peso:0,
            questaoFormularioId:formulario.questoes[key].questaoFormularioId
        };

        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        })

        //enviando para o banco 
        axios.post(process.env.REACT_APP_API + 'Alternativas/',alternativas, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then((response => {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200 || response.data.statusCode === 201) {
                //adicionar alternativa em memória
                alternativas.questaoAlternativaId = response.data.value;
                var updatedList = {...formulario};
                updatedList.questoes[key].alternativas.push(alternativas);
                setFormulario(updatedList);
                atualizarAlternativas(key);
                atualizarQuestao(key);          
            }
            else {
                Swal.fire({
                    title: 'Não foi possível gravar',
                    text: response.data.value.message,
                    icon: 'error',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
                return;
            }
        })).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        });
    }

    const ordenarAlternativas = (key) => {
        let updatedList = {...formulario};
        //ordenar alternativas
        updatedList.questoes[key].alternativas.forEach((item,indice) => {
            updatedList.questoes[key].alternativas[indice].ordem = indice+1;
            updatedList.questoes[key].alternativas[indice].descricao = letras[indice] + " - " + updatedList.questoes[key].alternativas[indice].descricao.substring(4);
        });
        setFormulario(updatedList);
    }

    const delAlternativa = (key,altKey) => {
        Swal.fire({
            title: "Tem certeza?",
            text: "Você não poderá recuperar estes dados!",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#2F4F4F",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText:"Cancelar",
            }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Aguarde...',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                })

                axios.delete(process.env.REACT_APP_API + 'Alternativas/'+formulario.questoes[key].alternativas[altKey].questaoAlternativaId, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                .then((response => {
                    if(response.status !== 200) {
                        sessionStorage.clear();
                        window.location.href = process.env.REACT_APP_HOST+"login";
                        return;
                    }
                    if(response.data.statusCode === 200)
                    {
                        let updatedList = {...formulario};
                        updatedList.questoes[key].alternativas.splice(altKey,1); //excluir da memória
                        setFormulario(updatedList);
                        ordenarAlternativas(key);
                        atualizarAlternativas(key);
                        atualizarQuestao(key);
                    }
                    else
                    {
                        Swal.fire({
                            title: 'Não foi possível gravar',
                            text: response.data.value.message,
                            icon: 'error',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText:'Fechar'
                        })
                        return;
                    }
                })).catch((error) => {
                    sessionStorage.clear();
                    window.location.href = process.env.REACT_APP_HOST+"login";
                });
                
            }
        });
    }

    const delQuestao = (key) => {
        Swal.fire({
            title: "Tem certeza?",
            text: "Você não poderá recuperar estes dados!",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#2F4F4F",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText:"Cancelar",
            }).then((result) => {
            if (result.isConfirmed) {

                Swal.fire({
                    title: 'Aguarde...',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                })

                axios.delete(process.env.REACT_APP_API + 'Questoes/'+formulario.questoes[key].questaoFormularioId, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                .then((response => {
                    if(response.status !== 200) {
                        sessionStorage.clear();
                        window.location.href = process.env.REACT_APP_HOST+"login";
                        return;
                    }
                    if(response.data.statusCode === 400) {
                        Swal.fire({
                            title: 'Não foi possível excluir',
                            text: response.data.value.message,
                            icon: 'error',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText:'Fechar'
                        })
                        return;
                    }
                    else {
                        editFormulario();
                    }
                })).catch((error) => {
                    sessionStorage.clear();
                    window.location.href = process.env.REACT_APP_HOST+"login";
                });

            }
        });
    }

    const editarDados = (key, ativo, tipo) => {
        var updatedList = {...formulario};
        if(tipo === 1) //vertical
        {
            updatedList.questoes[key].vertical = ativo;
        }
        else if(tipo === 2)//obrigatório
        {
            updatedList.questoes[key].obrigatorio = ativo;
        }
        else //quebra de página
        {
            let secaoFinal = updatedList.questoes[key].secaoFinal;
            let secaoInicial = 1;
            updatedList.questoes[key].quebraPagina = ativo;
            if(ativo) secaoFinal++;
            else secaoFinal--;
            //atualizando seções
            updatedList.questoes.forEach((item, indice) => {
                updatedList.questoes[indice].secaoFinal = secaoFinal;
                updatedList.questoes[indice].secao = secaoInicial;
                if(item.quebraPagina) {
                    secaoInicial++;
                }
            })
        }
        setFormulario(updatedList);

        //habilitano btngravar
        var btn = btnGravar;
        btn[key] = true;
        setBtnGravar(btn);
    }

    const controleModal = (state,key) => {
        var updatedList = [...indicadores];
        setIndicadoresFilter(updatedList);
        setModal(state);
        setKeyModal(key);
    }

    const searchIndicador = (event) => {
        var updatedList = [...indicadores];
        const filtered = updatedList.filter(item => {
            return item.descricao.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
        });
        setIndicadoresFilter(filtered);
    }

    const selecionarIndicador = (a) => {
        var updatedList = {...formulario};
        updatedList.questoes[keyModal].avaliacaoArea.avaliacaoAreaId = a.avaliacaoAreaId;
        updatedList.questoes[keyModal].avaliacaoArea.avaliacaoDimensao.avaliacaoIndicador.avaliacaoIndicadorId = a.avaliacaoDimensao.avaliacaoIndicador.avaliacaoIndicadorId;
        updatedList.questoes[keyModal].avaliacaoArea.avaliacaoDimensao.avaliacaoDimensaoId = a.avaliacaoDimensao.avaliacaoDimensaoId;

        updatedList.questoes[keyModal].avaliacaoArea.descricao = a.descricao;
        updatedList.questoes[keyModal].avaliacaoArea.avaliacaoDimensao.descricao = a.avaliacaoDimensao.descricao;
        updatedList.questoes[keyModal].avaliacaoArea.avaliacaoDimensao.avaliacaoIndicador.descricao = a.avaliacaoDimensao.avaliacaoIndicador.descricao;

        setFormulario(updatedList);
        setModal(false);

        //habilitano btngravar
        var btn = btnGravar;
        btn[keyModal] = true;
        setBtnGravar(btn);
    }

    const adicionarNovo = (tipoQuestaoId) => {
        var updatedList = {...formulario};
        var ultimoItem = {numeroQuestao:0};
        if(updatedList.questoes.length > 0)
            ultimoItem = updatedList.questoes.pop();
        var newItem = {
            numeroQuestao:(ultimoItem.numeroQuestao+1),
            questao:(ultimoItem.numeroQuestao+1)+" - Escreva aqui a descrição da questão",
            respostas:"",
            obrigatorio:true,
            vertical:true,
            quebraPagina:false,
            secao:1,
            ativo:true,
            secaoFinal:1,
            tipoQuestaoId:tipoQuestaoId,
            avaliacaoAreaId:indicadores[0].dimensoes[0].areas[0].avaliacaoAreaId,
            formularioId:formulario.formularioId
        };

        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        })
        
        axios.post(process.env.REACT_APP_API + 'Questoes/',newItem, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then((response => {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            Swal.close();
            if(response.data.statusCode === 200 || response.data.statusCode === 201) {
                editFormulario();
            }
            else {
                Swal.fire({
                    title: 'Não foi possível gravar',
                    text: response.data.value.message,
                    icon: 'error',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
                return;
            }
        })).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        });
    }

    const trocarOrdem = (key, altKey, posicao) => {
        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        let from = altKey;
        let to = altKey-posicao;
        formulario.questoes[key].alternativas.splice(to, 0, formulario.questoes[key].alternativas.splice(from, 1)[0]);
        formulario.questoes[key].alternativas.forEach((item,indice) => {
            formulario.questoes[key].alternativas[indice].ordem = indice+1;
        })

        var updatedList = {...formulario};
        setFormulario(updatedList);

        ordenarAlternativas(key);
        atualizarAlternativas(key);
        atualizarQuestao(key);
    }

    const trocarOrdemQuestao = (key, posicao) => {
        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        let from = key;
        let to = key-posicao;
        formulario.questoes.splice(to, 0, formulario.questoes.splice(from, 1)[0]);

        formulario.questoes.forEach((item,indice) => {
            formulario.questoes[indice].numeroQuestao = indice+1;
            formulario.questoes[indice].questao = indice+1 + ' - ' + formulario.questoes[indice].questao.substring(4);

            let envioDados = {
                questaoFormularioId: formulario.questoes[indice].questaoFormularioId,
                textoPreQuestao: formulario.questoes[indice].textoPreQuestao,
                numeroQuestao: formulario.questoes[indice].numeroQuestao,
                questao: formulario.questoes[indice].questao,
                respostas: formulario.questoes[indice].respostas,
                obrigatorio: formulario.questoes[indice].obrigatorio,
                vertical: formulario.questoes[indice].vertical,
                quebraPagina: formulario.questoes[indice].quebraPagina,
                secao: formulario.questoes[indice].secao,
                secaoFinal: formulario.questoes[indice].secaoFinal,
                tipoQuestaoId: formulario.questoes[indice].tipoQuestao.tipoQuestaoId,
                avaliacaoAreaId: formulario.questoes[indice].avaliacaoArea.avaliacaoAreaId,
                formularioId: formulario.formularioId,
                ativo: formulario.questoes[indice].ativo
            }
            //atualizando os dados
            axios.put(process.env.REACT_APP_API + 'Questoes/'+formulario.questoes[indice].questaoFormularioId,envioDados, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
            .then((response => {
                if(response.status !== 200) {
                    sessionStorage.clear();
                    window.location.href = process.env.REACT_APP_HOST+"login";
                    return;
                }
                if(indice === formulario.questoes.length-1)
                    Swal.close();
            })).catch((error) => {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
            });
        });

        var updatedList = {...formulario};
        setFormulario(updatedList);
        document.getElementById('div'+(key-posicao)).scrollIntoView();
    }

    const controleModalVisualizar = (state) => {
        setModalVisualizar(state);
    }

    return (
        <div> 
            <BarraNavegacao/>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-12">
                        <div className="background-topo rounded-top p-3">
                            <div className="text-center mb-2 rounded p-2">
                                <img src={LogoWebSai} alt="Logo" style={{width:150}} className="mb-2"/>
                                <h4 className="mb-0 text-white">{formulario.titulo}</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">

                        <div className="background rounded-bottom p-3 mb-2"> 
                            <p className={loading ? "text-center mb-0":"d-none"}>
                                {'Carregando... '}
                                <RotatingLines
                                    strokeColor="gray"
                                    strokeWidth="5"
                                    animationDuration="0.75"
                                    width="20"
                                    visible={loading}
                                />
                            </p>
                            {
                                typeof formulario.questoes !== "undefined" ?
                                formulario.questoes.map((questionario,key) => 
                                    <div id={"div"+key} className={"bg-white rounded p-3 border mb-2"}>
                                        <div className={btnGravar[key] ? "row":"d-none"}>
                                            <div className="col-sm-12 mb-2">
                                                <button type="button" onClick={() => {gravar(key)} } className="btn btn-custom btn-sm float-end"><BiSave/> Gravar</button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <label>Questão</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">{questionario.numeroQuestao}</span>
                                                    <input type="text" name="questao" key={'descricao'+key} onChange={(e) => { handledFormulario(e,key,null) }} className="form-control" value={questionario.numeroQuestao < 10 ? questionario.questao.substring(4) : questionario.numeroQuestao < 100 ? questionario.questao.substring(5) : questionario.questao.substring(6)}/>
                                                    <button className="btn btn-outline-secondary" type="button" onClick={() => {trocarOrdemQuestao(key,1)}} key={key+'btnUpQuestao'}><BiChevronUp size={25}/></button>
                                                    <button className="btn btn-outline-secondary" type="button" onClick={() => {trocarOrdemQuestao(key,-1)}} key={key+'btnDownQuestao'}><BiChevronDown size={25}/></button>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mb-2">
                                                <label>Texto pré-questão</label>
                                                <input type="text" name="textoPreQuestao" key={'textoPreQuestao'+key} value={questionario.textoPreQuestao} onChange={(e) => { handledFormulario(e,key,null) }} className="form-control" placeholder='Opcional'/>
                                            </div>
                                        </div>
                                        <div className="row d-flex">
                                            <div className="col-12">
                                                <label>Alternativas</label>
                                            </div>
                                        </div>
                                        {questionario.alternativas.map((alt, altKey) =>
                                        <div className="form-check">
                                            <input className="form-check-input" type={"radio"} name={'check'+key}/>
                                            <div className="col-sm-6">
                                                <div className="input-group">
                                                    {
                                                        questionario.tipoQuestao.tipoQuestaoId !== "0d2d6257-ad26-48db-83f2-fc6113379297" ?
                                                        <span className="input-group-text">{letras[alt.ordem-1]}</span>
                                                        :
                                                        letras[alt.ordem-1] === 'A' ? 
                                                        <span className="input-group-text"><BsEmojiHeartEyesFill size={25} className='text-success'/></span>
                                                        :
                                                        letras[alt.ordem-1] === 'B' ? 
                                                        <span className="input-group-text"><BsFillEmojiSmileFill size={25} color='MediumSeaGreen'/></span>
                                                        :
                                                        letras[alt.ordem-1] === 'C' ? 
                                                        <span className="input-group-text"><BsEmojiNeutralFill size={25} className='text-warning'/></span>
                                                        :
                                                        letras[alt.ordem-1] === 'D' ? 
                                                        <span className="input-group-text"><BsFillEmojiFrownFill size={25} color='coral'/></span>
                                                        :
                                                        letras[alt.ordem-1] === 'E' ? 
                                                        <span className="input-group-text"><BsEmojiAngryFill size={25} className='text-danger'/></span>
                                                        :
                                                        <span className="input-group-text">{letras[alt.ordem-1]}</span>
                                                    }
                                                    
                                                    <input type="text" className="form-control" value={alt.descricao.substring(4)} name="descricao" key={key+'inputAlt'+altKey} onChange={(e) => { handledFormulario(e,key,altKey) }} aria-label="Alternativa" aria-describedby="button-addon2"/>
                                                    <button className="btn btn-outline-secondary" onClick={() => {trocarOrdem(key,altKey,1)}} type="button" key={key+'btnUp'+altKey}><BiChevronUp size={25}/></button>
                                                    <button className="btn btn-outline-secondary" onClick={() => {trocarOrdem(key,altKey,-1)}} type="button" key={key+'btnDown'+altKey}><BiChevronDown size={25}/></button>
                                                    <button className="btn btn-outline-secondary" onClick={() => {delAlternativa(key,altKey)}} type="button" key={key+'btnRemove'+altKey}><BiTrash size={25}/></button>
                                                </div>
                                            </div>
                                        </div>
                                        )}
                                        <hr/>
                                        <div className="row">
                                            <div className="col-sm-4 mb-2">
                                                <div className="btn-group" role="group" aria-label="Adicionar e Remover">
                                                    {
                                                        questionario.tipoQuestao.tipoQuestaoId === "0d2d6257-ad26-48db-83f2-fc6113379297" && questionario.alternativas.length < 5 ?
                                                        <ButtonGroup>
                                                            <DropdownButton variant='light' as={ButtonGroup} title="Nova Alternativa" id="bg-nested-dropdown">
                                                                <Dropdown.Item eventKey="1" onClick={() => {addSmile(key,'A - Excelente')}}><BsEmojiHeartEyesFill size={25} className='text-success'/> Excelente</Dropdown.Item>
                                                                <Dropdown.Item eventKey="2" onClick={() => {addSmile(key,'B - Bom')}}><BsFillEmojiSmileFill size={25} color='MediumSeaGreen'/> Bom</Dropdown.Item>
                                                                <Dropdown.Item eventKey="2" onClick={() => {addSmile(key,'C - Regular')}}><BsEmojiNeutralFill size={25} className='text-warning'/> Regular</Dropdown.Item>
                                                                <Dropdown.Item eventKey="2" onClick={() => {addSmile(key,'D - Ruim')}}><BsFillEmojiFrownFill size={25} color='coral'/> Ruim</Dropdown.Item>
                                                                <Dropdown.Item eventKey="2" onClick={() => {addSmile(key,'E - Péssimo')}}><BsEmojiAngryFill size={25} className='text-danger'/> Péssimo</Dropdown.Item>
                                                            </DropdownButton>
                                                            <button type="button" key={'btnRemover'+key} onClick={() => {delQuestao(key)}} className="btn btn-danger btn-sm"><BiTrash size={25}/> Remover Questão</button>
                                                        </ButtonGroup>
                                                        : questionario.tipoQuestao.tipoQuestaoId !== "0d2d6257-ad26-48db-83f2-fc6113379297" ?
                                                        <>
                                                        <button type="button" key={'btnNova'+key} onClick={() => {addAlternativa(key)}} className={"btn btn-light btn-sm"}><BiPlus size={25}/> Nova Alternativa</button>
                                                        <button type="button" key={'btnRemover'+key} onClick={() => {delQuestao(key)}} className="btn btn-danger btn-sm"><BiTrash size={25}/> Remover Questão</button>
                                                        </>
                                                        : <button type="button" key={'btnRemover'+key} onClick={() => {delQuestao(key)}} className="btn btn-danger btn-sm"><BiTrash size={25}/> Remover Questão</button>
                                                    }
                                                </div>
                                            </div>
                                            <div className={"col-sm-8 text-end"}>
                                                <div className="btn-group" role="group" aria-label="Coluna ou Linha">
                                                    <input type="radio" className="btn-check" name={'btn'+key} id={'btn1'+key} defaultChecked={questionario.vertical} autoComplete="off"/>
                                                    <label className="btn btn-outline-success" htmlFor={'btn1'+key} onClick={() => {editarDados(key, true,1)}}>Exibir vertical</label>

                                                    <input type="radio" className="btn-check" name={'btn'+key} id={'btn2'+key} autoComplete="off" defaultChecked={questionario.vertical?false:true}/>
                                                    <label className="btn btn-outline-success" htmlFor={'btn2'+key} onClick={() => {editarDados(key, false,1)}}>Exibir horizontal</label>
                                                    {
                                                        formulario.questoes.length-1 !== key ?
                                                        <>
                                                            <input type="checkbox" className="btn-check" id={'btn4'+key} autoComplete="off" defaultChecked={questionario.quebraPagina}/>
                                                            <label className="btn btn-outline-success" htmlFor={'btn4'+key} onClick={() => {editarDados(key,questionario.quebraPagina?false:true,3)}}>Quebra de Página</label>
                                                        </>
                                                        : null
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-sm-12 mt-3">
                                            <table className="table table-bordered table-sm">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Eixo</th>
                                                        <th>Dimensão</th>
                                                        <th>Objetivo</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{questionario.avaliacaoArea.avaliacaoDimensao.avaliacaoIndicador.descricao}</td>
                                                        <td>{questionario.avaliacaoArea.avaliacaoDimensao.descricao}</td>
                                                        <td>{questionario.avaliacaoArea.descricao}</td>
                                                        <td>
                                                            <button className="btn btn-sm btn-warning" onClick={() => controleModal(true, key)}><BiSolidEdit></BiSolidEdit> Alterar</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ) : null
                            }
                            
                            <div className="text-center mb-2">
                                <ButtonGroup>
                                    <DropdownButton variant='secondary' as={ButtonGroup} title="Adicionar Novo" id="bg-nested-dropdown">
                                        <Dropdown.Item eventKey="1" onClick={() => adicionarNovo("e070b48c-c226-44d0-854e-9a65682a645e")}>Seleção única</Dropdown.Item>
                                        <Dropdown.Item eventKey="2" onClick={() => adicionarNovo("0d2d6257-ad26-48db-83f2-fc6113379297")}>Lista smile</Dropdown.Item>
                                    </DropdownButton>
                                    <button type="button" onClick={() => controleModalVisualizar(true)} className="btn btn-light btn-sm"><BiSearchAlt size={25}/> Visualizar</button>
                                </ButtonGroup>
                            </div> 

                            <hr/>
                            <div className="text-center mt-3">
                                <svg viewBox="0 0 1000 656.5" style={{width:70}}>
                                    <title>Centro Paula Souza</title>
                                    <path fill="#af0916" d="M760 181.2c.8-23.8 11.1-33.3 45.2-33.3H993V81.4H817c-83.2 0-130 35.6-130 103 0 131.5 240.1 104.6 240.1 174.3 0 23.8-12.7 36.5-45.2 36.5H636.3c24.8-30.3 40-69.4 40-114.1 0-112.5-72.9-207.5-196.4-207.5-111.7 0-191.7 84-191.7 209.1v31.1h-84.6c-65.7 0-130.7-42.8-130.7-123.6s65-123.6 130.7-123.6h53.9V0H191C102.2 0 0 68.1 0 190.1s102.2 190.1 190.9 190.1h97.3v276.2h69.7V380.2h132.7v-66.5H357.9v-18.4c0-104.6 55.5-155.3 122-155.3 74.5 0 126.7 54.6 126.7 132.3 0 66.7-36.1 110-93.3 122.8h-88.9v66.5H882c67.3 0 118-34.1 118-106.1 0-136.3-240.9-108.5-240-174.3" className="icon"></path>
                                    <path d="M481.6 560.8c-3.7 1.7-11.2 3.3-20.8 3.3-22.2 0-38.9-12.5-38.9-35.6 0-22 16.7-37 41.1-37 9.8 0 16 1.9 18.7 3.1l-2.4 7.4c-3.9-1.7-9.4-2.9-15.9-2.9-18.4 0-30.7 10.5-30.7 29 0 17.2 11.1 28.3 30.2 28.3 6.2 0 12.5-1.1 16.6-2.9l2.1 7.3zm16.8-21.2c.2 12.4 9.1 17.5 19.4 17.5 7.4 0 11.8-1.2 15.6-2.6l1.8 6.5c-3.6 1.5-9.8 3.1-18.8 3.1-17.4 0-27.8-10.2-27.8-25.5 0-15.2 10-27.2 26.5-27.2 18.4 0 23.3 14.5 23.3 23.8 0 1.9-.2 3.3-.4 4.3h-39.6zm30.1-6.6c.1-5.8-2.7-14.9-14.2-14.9-10.4 0-14.9 8.5-15.8 14.9h30zm22.6-6.7c0-5.2-.1-9.5-.5-13.7h9.1l.6 8.3h.2c2.8-4.8 9.3-9.5 18.7-9.5 7.8 0 20 4.2 20 21.5v30.2H589V534c0-8.1-3.4-14.9-13.1-14.9-6.8 0-12 4.3-13.8 9.4-.4 1.1-.7 2.7-.7 4.3v30.4h-10.3v-36.9zm76.8-28.2v14.5h14.7v7h-14.7v27.3c0 6.2 2 9.8 7.7 9.8 2.7 0 4.7-.3 6-.6l.5 6.9c-2 .7-5.1 1.3-9.1 1.3-4.8 0-8.6-1.4-11.1-3.9-2.9-2.7-4-7.2-4-13.1v-27.6h-8.8v-7h8.8v-12.1l10-2.5zm26.2 30.3c0-6-.1-11-.5-15.8h9l.3 9.9h.5c2.6-6.8 8.7-11.1 15.6-11.1 1.2 0 2 .1 2.9.3v8.6c-1-.2-2.1-.3-3.5-.3-7.2 0-12.4 4.9-13.8 11.8-.2 1.3-.5 2.7-.5 4.3V563h-10.2v-34.6zm88.2 9.1c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.5 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.1 19.4 9.8 0 17.2-8.2 17.2-19.6 0-8.6-4.8-19.4-16.9-19.4-12.2 0-17.4 10-17.4 19.6m-270.9 47.3c4.9-.7 11.3-1.4 19.5-1.4 10 0 17.4 2.1 22.1 5.9 4.3 3.3 6.9 8.5 6.9 14.7 0 6.4-2.1 11.4-6.1 15-5.4 5.1-14.1 7.7-24 7.7-3 0-5.9-.1-8.2-.6v28.2h-10.2v-69.5zm10.1 33.9c2.2.5 5 .7 8.4.7 12.3 0 19.7-5.3 19.7-15 0-9.3-7.4-13.8-18.6-13.8-4.4 0-7.8.3-9.6.7v27.4zm79.9 35.6l-.8-6.4h-.3c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.4-6.1c4.7-2.7 11.5-4.5 18.5-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.3zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629zm73.8 12c0 5.2.1 9.8.4 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm17-60.3h10.3v74.1h-10.3zm58.9 74.1l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-24 1.6-24 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.3-1 .6-2 .6-2.9V629zm50.2 14.7c4.5 2.5 11.2 4.6 18.2 4.6 10.4 0 16.5-4.9 16.5-12 0-6.6-4.2-10.3-14.8-14-12.9-4.1-20.8-10-20.8-19.9 0-11 10.1-19.1 25.4-19.1 8 0 13.9 1.7 17.4 3.4l-2.8 7.4c-2.6-1.2-7.8-3.3-15-3.3-10.7 0-14.8 5.7-14.8 10.5 0 6.6 4.8 9.8 15.7 13.6 13.3 4.6 20.1 10.3 20.1 20.7 0 10.9-9 20.2-27.6 20.2-7.6 0-15.9-2-20.1-4.5l2.6-7.6zm110.4-14.6c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.6 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.2 19.4 9.8 0 17.2-8.3 17.2-19.6 0-8.5-4.8-19.4-16.9-19.4-12.3 0-17.5 10-17.5 19.6m105 11.4c0 5.2.1 9.8.5 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm10.7 8.5l25.6-29.8c2.4-2.7 4.8-5.1 7.3-7.8v-.2h-30.6v-7.4h43.1l-.1 5.8-25.2 29.3c-2.3 2.8-4.6 5.3-7.2 7.9v.2h33v7.3h-45.9v-5.3zm87.6 5.3l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.5 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629z" className="title"></path>
                                </svg>
                            </div>


                            <Modal size="lg" show={modal} onHide={() => controleModal(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Selecionar Eixo</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="row">
                                        <div className="col-sm-12 mb-3">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping"><BiSearch /></span>
                                                <input type="text" className="form-control" placeholder="Filtrar por eixo..." onChange={searchIndicador}/>
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <table className="table table-bordered table-sm">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Eixos</th>
                                                        <th>Dimensões / Objetivos</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        indicadoresFilter.map((i,key) =>
                                                            <tr>
                                                                <td className="fw-bold">{i.descricao}</td>
                                                                <td>
                                                                <ul>
                                                                {
                                                                    i.dimensoes.map((d) => 
                                                                        <div>
                                                                            {
                                                                                <li className="fw-bold">{d.descricao}</li>
                                                                            }
                                                                            <ul>
                                                                            {
                                                                                d.areas.map(a =>
                                                                                    <li>{a.descricao} <button className="btn btn-link btn-sm" onClick={() => selecionarIndicador(a)}>Selecionar</button></li>
                                                                                )
                                                                            }
                                                                            </ul>
                                                                        </div>
                                                                    )
                                                                }
                                                                </ul>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table> 
                                        </div>
                                    </div>
                                                 
                                </Modal.Body>
                            </Modal>


                            <Modal size="xl" show={modalVisualizar} onHide={() => controleModalVisualizar(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title className='w-100'>{formulario.titulo} <PDFDownloadLink document={<PDFFile formulario={formulario} questoes={formulario.questoes}></PDFFile>} fileName="Formulário WebSAI"><button className="btn btn-custom btn-sm float-end mx-2"><BiDownload></BiDownload> Gerar PDF</button></PDFDownloadLink></Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{background:"LightGrey"}}>
                                    <div className="row">
                                        <div>
                                            <div className={typeof formulario.questoes !== "undefined" && formulario.questoes.length > 0 ? 'd-none':'alert alert-warning'}>Este formulário não possui questões adicionadas.</div>
                                        {
                                            typeof formulario.questoes !== "undefined" ?
                                            formulario.questoes.map((questao,key) => 
                                            <div>
                                                <div className={questao.textoPreQuestao ? "text-center text-bg-secondary rounded p-2 fw-bold mb-2 text-uppercase" : "d-none"}>
                                                    {questao.textoPreQuestao}
                                                </div>
                                                <div className="bg-white rounded p-3 border mb-2">
                                                    <p className="mb-2 fw-bold">
                                                        {questao.questao} <span className={questao.obrigatorio?"d-none":"fst-italic text-secondary"}>(Opcional)</span>
                                                    </p>
                                                    {
                                                        questao.alternativas.map((alt) => 
                                                            <div className={questao.vertical ? "form-check" : "form-check form-check-inline"}>
                                                                <input className="form-check-input" type="radio" name={'check'+key}/>
                                                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                                    { 
                                                                    questao.tipoQuestao.tipoQuestaoId === '0d2d6257-ad26-48db-83f2-fc6113379297' && letras[alt.ordem-1] === 'A' ? 
                                                                    <span><BsEmojiHeartEyesFill size={35} className='text-success'/> {alt.descricao.slice(4)}</span> 
                                                                    :
                                                                    questao.tipoQuestao.tipoQuestaoId === '0d2d6257-ad26-48db-83f2-fc6113379297' && letras[alt.ordem-1] === 'B' ? 
                                                                    <span><BsFillEmojiSmileFill size={35} color='MediumSeaGreen'/> {alt.descricao.slice(4)}</span> 
                                                                    :
                                                                    questao.tipoQuestao.tipoQuestaoId === '0d2d6257-ad26-48db-83f2-fc6113379297' && letras[alt.ordem-1] === 'C' ? 
                                                                    <span><BsEmojiNeutralFill size={35} className='text-warning'/> {alt.descricao.slice(4)}</span> 
                                                                    :
                                                                    questao.tipoQuestao.tipoQuestaoId === '0d2d6257-ad26-48db-83f2-fc6113379297' && letras[alt.ordem-1] === 'D' ? 
                                                                    <span><BsFillEmojiFrownFill size={35} color='coral'/> {alt.descricao.slice(4)}</span> 
                                                                    :
                                                                    questao.tipoQuestao.tipoQuestaoId === '0d2d6257-ad26-48db-83f2-fc6113379297' && letras[alt.ordem-1] === 'E' ? 
                                                                    <span><BsEmojiAngryFill size={35} className='text-danger'/> {alt.descricao.slice(4)}</span> 
                                                                    : <span>{alt.descricao}</span>
                                                                    } 
                                                                    </label>
                                                            </div>
                                                        )
                                                    }
                                                    <div className="mt-2 rounded border p-1 bg-light">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <small><strong>Eixo:</strong> {questao.avaliacaoArea.avaliacaoDimensao.avaliacaoIndicador.descricao}</small>
                                                            </div>
                                                            <div className="col-12">
                                                                <small><strong>Dimensão:</strong> {questao.avaliacaoArea.avaliacaoDimensao.descricao}</small>
                                                            </div>
                                                            <div className="col-12">
                                                                <small><strong>Objetivo:</strong> {questao.avaliacaoArea.descricao}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            ):null 
                                        }
                                        </div>
                                    </div>           
                                </Modal.Body>
                            </Modal>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}